import React from "react";
import {graphql} from "gatsby";
import WhiteBoxes from "../components/sections/_white-boxes";
import HeaderSection from "../components/sections/_header-with-image";
import ListOfValidators from "../components/sections/_list-of-validators";
import ListOfPublications from "../components/sections/_list-of-publications";
import ThreeColsWithSplitBG from "../components/sections/_three-cols-with-split-bg";
import RoadmapSection from "../components/sections/_roadmap-section";
import HeaderWithImageAndSocials from "../components/sections/_header-with-image-and_socials";
import TextWithImageSection from "../components/sections/_text-with-image-section";
import UpcomingEvents from "../components/sections/_upcoming-events";
import PieChartSection from "../components/sections/_piechart-section";
import FaqSection from "../components/sections/_faq-section";
import TechSection from "../components/sections/_tech-section";
import PapersSection from "../components/sections/_papers-section";
import BenefitsSection from "../components/sections/_benefits-section";
import TeamMembersSection from "../components/sections/_team-member-section";
import PlainTextWithTitle from "../components/sections/_plain-text-with-title";
import GreyBoxesSection from "../components/sections/_grey-boxes-section";
import CenteredText from "../components/sections/_centered-text";
import HoverBoxesSection from "../components/sections/_hover-boxes-section";
import YellowSliderSection from "../components/sections/_yellow-slider-section";
import EcosystemSection from "../components/sections/_row-of-posts-section";
import SmallRoadmapSection from "../components/sections/_small-roadmap-section";
import RowOfPostsSection from "../components/sections/_row-of-posts-section";
import PartnersSection from "../components/sections/_partners-section";
import CodeblockSection from "../components/sections/_codeblock-section";

export class DataProvider {
    constructor(raw) {
        this.raw = raw;
    };

    getCurrentPageSections = () => {
        let sections = this.raw.contentfulPage.sections;

        if (sections === null) {
            return [];
        }

        return this.raw.contentfulPage.sections.map(section => {
            return {
                id: section.id,
                contentful_id: section.contentful_id,
                type: section.internal.type.replace('Contentful', ''),
            }
        });
    };

    getElementById = (id) => {
        let elements = this.raw.allContentfulEntry.edges.filter(function (entry) {
            return entry.node.id === id;
        });

        if (elements.length !== 1) {
            return null;
        }

        return elements[0].node;
    };

    renderPageSection = (section) => {
        const component = componentMap[section.type];
        if (!component) {
            console.error(`Warning: Component failed to render! Component id: ${section.id}`);
            return <></>;
        }

        // Events page with dynamic event posts
        if (section.contentful_id === `5DQG697kWCn5Ka27lLgBdK` || section.contentful_id === `2wXIXJsNYVyeCsgseo6uVW`) {
            return React.createElement(componentMap[section.type], {
                content: this.getElementById(section.id),
                dataProvider: this,
                dynamicEvents: true
            });
        }

        // Blog post section auto population
        if (section.contentful_id === `TMplZ19sU6JtlzpVCj8yf`) {
            return React.createElement(componentMap[section.type], {
                content: this.getElementById(section.id),
                dataProvider: this,
                dynamicPosts: true
            });
        }

        return React.createElement(componentMap[section.type], {content: this.getElementById(section.id)});
    }
}

export const getImage = (image) => {
    if (image === null) {
        return {url: '', title: ''};
    }

    return image;
}

export const componentMap = {
    "HeaderWithImage": HeaderSection,
    "HeaderWithImageAndSocials": HeaderWithImageAndSocials,
    "ListOfValidators": ListOfValidators,
    "ListOfPublications": ListOfPublications,
    "ThreeColsWithSplitBg": ThreeColsWithSplitBG,
    "WhiteBoxesSection": WhiteBoxes,
    "RoadmapSection": RoadmapSection,
    "CallToActionSectionWithImage": TextWithImageSection,
    "EventSliderSection": UpcomingEvents,
    "TokenChartSection": PieChartSection,
    "FaqSection": FaqSection,
    "ProductExplainerSection": TechSection,
    "PapersSection": PapersSection,
    "BenefitsSection": BenefitsSection,
    "TeamMembersSection": TeamMembersSection,
    "HeaderWithoutImageSection": PlainTextWithTitle,
    "GreyBoxesSection": GreyBoxesSection,
    "CenteredTextSection": CenteredText,
    "HoverBoxesSection": HoverBoxesSection,
    "YellowSliderSection": YellowSliderSection,
    "EcosystemGridSection": EcosystemSection,
    "SmallRoadmapSection": SmallRoadmapSection,
    "RowOfPostsSection": RowOfPostsSection,
    "PartnersSection": PartnersSection,
    "CodeblockSection": CodeblockSection,
}

export const query = graphql`
    fragment CurrentPageDetails on ContentfulPage {
        id
        title
        internal {
            type
        }
        sections {
            ... on ContentfulEntry {
                id
                contentful_id
                internal {
                    type
                }
            }
        }
    }
    fragment MenuDetails on ContentfulMenu {
        elements {
            title
            url
            isExternal
            elements {
                title
                url
                isExternal
            }
        }
    }
    fragment AllEntryDetails on ContentfulEntry {
        ... on ContentfulHeaderWithImage {
            id
            title
            smallTitle
            body {
                raw
            }
            ctaText
            ctaUrl
            isExternal
            secondaryCtaText
            secondaryCtaUrl
            isSecondaryExternal
            videoInsteadOfImage
            image {
                url
                title
            }
        }
        ... on ContentfulThreeColsWithSplitBg {
            id
            title
            titleImage {
                url
                title
            }
            body {
                raw
            }
            backgroundColor
            colsBackground
            hideTitle
#            ctaText
#            ctaUrl
            showAsProgress
            elements {
                title
                body { raw }
                image {
                    url
                    title
                }
                ctaText
                ctaUrl
                isInternalCta
            }
        }
        ... on ContentfulListOfValidators {
            id
            title
            ctaUrl
            ctaText
            body {
                raw
            }
            images {
                title
                url
            }
        }
        ... on ContentfulWhiteBoxesSection {
            id
            title
            body { raw }
            elements {
                ctaUrl
                ctaText
                title
                isExternal
                image {
                    url
                    title
                }
                body {
                    raw
                }
            }
        }
        ... on ContentfulRoadmapSection {
            id
            title
            year
            active
            isOpen
            elements {
                title
                elements {
                    title
                    extraInfo
                    active
                    ctaUrl
                    ctaText
                    body {
                        raw
                    }
                }
            }
        }
        ... on ContentfulHeaderWithImageAndSocials {
            title
            smallTitle
            ctaUrl
            ctaText
            isExternal
            id
            image {
                url
                title
            }
            body { raw }
            socalLinks {
                url
                image {
                    url
                    title
                }
            }
        }
        ... on ContentfulCallToActionSectionWithImage {
            body {
                raw
            }
            title
            ctaUrl
            ctaText
            imageLocation
            id
            image {
                url
                title
            }
        }
        ... on ContentfulTokenChartSection {
            id
            title
            body {
                raw
            }
            elements {
                title
                amount
                amountPercent
                body {
                    raw
                }
            }
        }
        ... on ContentfulEventSliderSection {
            id
            contentful_id
            title
            color
            elements {
                title
                isExternalLink
                date
                excerpt
                slug
                jointEventUrl
            }
        }
        ... on ContentfulFaqSection {
            id
            title
            elements {
                id
                question
                answer {
                    raw
                }
            }
        }
        ... on ContentfulProductExplainerSection {
            id
            title
            elements {
                id
                sliderTitle
                title
                body { raw }
                image {
                    url
                    title
                }
                ctaUrl
                ctaText
            }
        }
        ... on ContentfulPapersSection {
            id
            title
            body { raw }
            elements {
                id
                title
                subtitle
                elements {
                    title
                    publicationYear
                    file {
                        url
                        title
                    }
                    url
                }
            }
        }
        ... on ContentfulBenefitsSection {
            id
            title
            ctaUrl
            ctaText
            elements {
                id
                title
                body { raw }
                image {
                    url
                    title
                }
            }
        }
        ... on ContentfulHeaderWithoutImageSection {
            id
            title
            smallTitle
            body { raw }
        }
        ... on ContentfulTeamMembersSection {
            id
            title
            body { raw }
            downloadPictures
            elements {
                id
                name
                position
                body { raw }
                image {
                    url
                    title
                }
            }
        }
        ... on ContentfulGreyBoxesSection {
            id
            title
            elements {
                id
                title
                body { raw }
                image {
                    url
                    title
                }
                files {
                    url
                    title
                }
            }
        }
        ... on ContentfulCenteredTextSection {
            id
            title
            ctaUrl
            ctaText
            isExternal
            secondaryCtaText
            secondaryCtaUrl
            isSecondaryExternal
            thirdCtaText
            thirdCtaUrl
            isThirdExternal
        }
        ... on ContentfulHoverBoxesSection {
            id
            title
            body { raw }
            elements {
                id
                title
                body { raw }
                image {
                    url
                    title
                }
            }
        }
        ... on ContentfulYellowSliderSection {
            id
            title
            body { raw }
            elements {
                id
                title
                body { raw }
                ctaText
                ctaUrl
                image {
                    url
                    title
                }
            }
        }
        ... on ContentfulSmallRoadmapSection {
            id
            title
            ctaText
            ctaUrl
            elements {
                title
                subtitle
                checked
            }
        }
        ... on ContentfulRowOfPostsSection {
            id
            title
            splitTitle
            body { raw }
            elements {
                ... on ContentfulBlogPost {
                    id
                    title
                    slug
                    category {
                        slug
                    }
                    preview:excerpt { raw }
                    image {
                        url
                        title
                    }
                    publishedAt(formatString: "MMMM DD, YYYY")
                }
                ... on ContentfulRowOfPostsElement {
                    id
                    title
                    category {
                        slug
                    }
                    body { raw }
                    image {
                        url
                        title
                    }
                    openOnNewPage
                    ctaText
                    ctaUrl
                    publishedAt(formatString: "MMMM DD, YYYY")
                }
            }
        }
        ... on ContentfulPartnersSection {
            id
            title
            backgroundColor
            logos {
                url
                title
            }
        }
        ... on ContentfulCodeblockSection {
            id
            title
            body { raw }
            code { raw }
        }
    }
`;